import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Footer from '../../Navigation/components/Footer';
import Header from '../../Navigation/components/Header';
import MDSSidebar from '../../Navigation/components/Sidebar/index';
import { useSidebar } from '../../Navigation/contexts';
import { fetchNotifications } from '../../apis/notifications.api';
import { Image } from '../../components';
import { SnackBarMessage } from '../../components/SnackBar/SnackBar';
import { useGlobalStateContext } from '../../context/GlobalStateContext/GlobalStateContext';
import { redirectToLogOut } from '../../utils/browser-helpers';
import { useIsDesktop } from '../../utils/mediaQueries';
import { footerLinks, resolveHeaderProps } from './AppLayout.config';
import './OneTrustFix.css';
import { notificationInterval, SIDE_NAV_MAP } from './constants';
import styles from './styles';
export const AppLayout = ({ children, isMenuDisabled }) => {
    const { t: text, i18n: { language, resolvedLanguage = 'en' }, } = useTranslation();
    const isDesktop = useIsDesktop();
    const { globalState: { merchant }, handleLogout, } = useGlobalStateContext();
    const { Sidebar, Menu, MenuItem } = MDSSidebar;
    const { toggleSidebar } = useSidebar();
    const navigate = useNavigate();
    const [notificationCount, setNotificationCount] = useState();
    /////////////////Notification icon count logic ///
    const [lastMessage, setLastMessage] = useState({});
    useEffect(() => {
        setNotificationCount(lastMessage?.totalUnreadCount);
    }, [lastMessage]);
    useEffect(() => {
        if (!merchant?.merchantNumber)
            return;
        const getNotifications = () => {
            fetchNotifications(merchant?.merchantNumber, 1, 10, false, language)
                .then((response) => {
                // set empty if no response
                setLastMessage(response ?? {});
            })
                .catch((error) => {
                console.error(error);
            });
        };
        getNotifications();
        const intervalId = setInterval(getNotifications, notificationInterval);
        return () => clearInterval(intervalId);
    }, [merchant?.merchantNumber]);
    // TODO: applayout notifications must be connected to notification inbox as they are separate from carousel notifications
    const handleLogoutClick = () => {
        handleLogout(redirectToLogOut);
    };
    return (
    /*    <div style={{border:'solid 1px'}}>Anka</div>*/
    _jsxs(Grid, { container: true, sx: styles.main, children: [_jsx(Grid, { item: true, sx: styles.headerWrapper, children: _jsx(Header, { ...resolveHeaderProps(resolvedLanguage, handleLogoutClick), 
                    /* language={language}
                              onLanguageChange={() => {}}*/
                    toggleSidebar: () => toggleSidebar(), renderOnSidebar: true }) }), _jsxs(Grid, { container: true, item: true, sx: styles.sideBarAndMainContainer, children: [_jsx(Grid, { item: true, sx: styles.sideBarWrapper, children: _jsxs(Sidebar, { customBreakpoint: '767px', children: [_jsx(Box, { sx: isMenuDisabled
                                        ? { '& a': { pointerEvents: 'none' }, flex: '1 1 0' }
                                        : { flex: '1 1 0' }, children: _jsx(Menu, { children: Object.keys(SIDE_NAV_MAP).map((key) => (_jsx(MenuItem, { onClick: (e) => {
                                                e.preventDefault();
                                                navigate(SIDE_NAV_MAP[key].route);
                                            }, ...(key === 'Sales' && !isDesktop && { dividerPosition: 'top' }), href: SIDE_NAV_MAP[key].route, icon: _jsx(Image, { src: '/assets/images/' + key.toLowerCase() + '-icon.svg', alt: SIDE_NAV_MAP[key].alt }), ...(key === 'Insights' && { notificationCount }), children: text(SIDE_NAV_MAP[key].ref) }, key))) }) }), !isDesktop && (_jsx(Footer, { ...footerLinks[resolvedLanguage], renderOnSidebar: true }))] }) }), _jsx(Grid, { container: true, item: true, direction: 'column', sx: styles.contentWrapper(isDesktop), children: _jsx(Grid, { item: true, sx: styles.childrenWrapper, children: children }) })] }), _jsxs(_Fragment, { children: [_jsx(SnackBarMessage, {}), isDesktop && (_jsx(Grid, { item: true, sx: styles.footerWrapper, children: _jsx(Footer, { ...footerLinks[resolvedLanguage], renderOnSidebar: false }) }))] })] }));
};
